import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("chatbots.channels.title"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v(_vm._s(_vm.$t("chatbots.channels.channel_description"))),
              ]),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goCreatePage()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VRow,
        {
          class: {
            "flex-filter": _vm.size_screen == "sm" || _vm.size_screen == "xs",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-filter-order1", class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.data,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onEditChannel(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-edit"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onViewChannel(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-view"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onRemoveChannel(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-delete"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                {
                  staticClass: "col-md-3 col-sm-12 mb-3",
                  class: {
                    "pl-0": _vm.size_screen == "md" || _vm.size_screen == "lg",
                  },
                },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer pb-0",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.$t(
                                        "data_quality.dataplex.profiling.fields.name"
                                      ),
                                      placeholder: _vm.$t(
                                        "data_quality.dataplex.profiling.fields.name"
                                      ),
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "name", $$v)
                                      },
                                      expression: "filters.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: _vm.$t(
                                        "data_quality.dataplex.profiling.fields.description"
                                      ),
                                      placeholder: _vm.$t(
                                        "data_quality.dataplex.profiling.fields.description"
                                      ),
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "filters.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary ",
                                      on: { click: _vm.onSearch },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("dialog-confirmation-component", {
        ref: "DIALOG_REMOVE_PROJECT",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de eliminar el Canal?",
        },
        on: { onConfirm: _vm.onConfirmRemoveChannel },
      }),
      _c(
        "dialogs-component",
        {
          ref: "DIALOG_PERMISSIONS_PROJECT",
          attrs: { title: "Permisos", width: 850 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                "actions-component",
                [
                  _c(
                    "template",
                    { slot: "actions" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "ml-1 btn-inca-secondary",
                          attrs: { outlined: "", dense: "", small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.addRowPermission()
                            },
                          },
                        },
                        [_vm._v(_vm._s("Agregar Permiso"))]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                VForm,
                { ref: "form_permission", attrs: { id: "form_permission" } },
                [
                  _c(VDataTable, {
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers_permissions,
                      items: _vm.permissions,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination_permissions.limit,
                      page: _vm.pagination_permissions.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination_permissions.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(
                          _vm.pagination_permissions,
                          "current",
                          $event
                        )
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.email",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            !item.new
                              ? _c("span", [_vm._v(_vm._s(item.email))])
                              : _vm._e(),
                            item.new
                              ? _c(VTextField, {
                                  attrs: {
                                    small: "",
                                    dense: "",
                                    outlined: "",
                                    "hide-details": "auto",
                                    rules: [
                                      function (v) {
                                        return (
                                          !!v || _vm.$t("common.field_required")
                                        )
                                      },
                                    ],
                                  },
                                  model: {
                                    value: item.email,
                                    callback: function ($$v) {
                                      _vm.$set(item, "email", $$v)
                                    },
                                    expression: "item.email",
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.owner",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(VCheckbox, {
                              attrs: {
                                small: "",
                                dense: "",
                                disabled: "",
                                "hide-details": "auto",
                              },
                              model: {
                                value: item.owner,
                                callback: function ($$v) {
                                  _vm.$set(item, "owner", $$v)
                                },
                                expression: "item.owner",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.view_permission",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(VCheckbox, {
                              attrs: {
                                small: "",
                                dense: "",
                                disabled: "",
                                "input-value": true,
                                "hide-details": "auto",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.edit_permission",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(VCheckbox, {
                              attrs: {
                                small: "",
                                dense: "",
                                "hide-details": "auto",
                              },
                              model: {
                                value: item.edit_permission,
                                callback: function ($$v) {
                                  _vm.$set(item, "edit_permission", $$v)
                                },
                                expression: "item.edit_permission",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.delete_permission",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(VCheckbox, {
                              attrs: {
                                small: "",
                                dense: "",
                                "hide-details": "auto",
                              },
                              model: {
                                value: item.delete_permission,
                                callback: function ($$v) {
                                  _vm.$set(item, "delete_permission", $$v)
                                },
                                expression: "item.delete_permission",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addPermissions(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("mdi-content-save"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deletePermissions(item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-delete"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination_permissions },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }